import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SesionService } from '../../services/sesion.service';
import { WebServicesService } from '../../services/web-services.service';
import { GeneralService } from '../../services/general.service';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { Pipe } from '@angular/core';
import { LoadCitiesPipe } from 'src/app/pipes/load-cities.pipe';
import { CrearPasajerosComponent } from '../crear-pasajeros/crear-pasajeros.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GetTravelersAPI, PostDeleteTravelersAPI } from 'src/app/models';

@Component({
  selector: 'app-filtro-lista',
  templateUrl: './filtro-lista.component.html',
  styleUrls: ['./filtro-lista.component.scss'],
  standalone: true,
  imports: [
    CrearPasajerosComponent,
    CommonModule,
    ReactiveFormsModule,
    NgbModule,
    FormsModule,
    TranslateModule,
  ],
  providers: [
    SesionService,
    WebServicesService,
    GeneralService,
    LoadCitiesPipe,
  ],
})
export class FiltroListaComponent implements OnInit {
  @Pipe({
    name: 'split',
    standalone: true,
  })
  @Input()
  title: any;
  @Input() type: any;
  @Input() exclude: any;
  @Input() valorBuscar: any;
  @Output() eventEmit = new EventEmitter<any>();
  @Output() eventClose = new EventEmitter<any>();
  items: any = [];
  select: any;
  last: any = [];
  stop: any = false;
  search: any;
  allItems: any = [];
  items_sel: any;
  muestra: any = false;
  doCheckRefresh: any = true;
  edit: any = false;
  viewPassenger: any = false;
  element: any;

  constructor(
    public session: SesionService,
    private activatedRoute: ActivatedRoute,
    public ws: WebServicesService,
    public toolService: GeneralService
  ) {
    this.session.userSubject.asObservable().subscribe((user) => {
      this.session.user = user;
    });
    this.ws.newComplemt = this.activatedRoute.snapshot.params.complement
      ? this.activatedRoute.snapshot.params.complement
      : 'pasajes';
  }

  transform(text: string, by: string, index: number = 1) {
    let arr = text.split(by);
    return arr[index];
  }

  ngOnChanges() {
    if (this.valorBuscar) {
      this.getItems(this.valorBuscar.valor);
    }
    //this.initialize();
  }

  /**
   * Emite que se a seleccionado una ciudad
   * @param item
   */
  eventSelect(item: any) {
    this.search = undefined;
    this.muestra = false;
    this.session.addCity(this.ws.newComplemt, item.city.split(',')[0]);

    this.eventEmit.emit(item);
  }

  closeModal() {
    this.eventClose.emit(false);
  }

  searchCity(item: any) {
    let elem = this.allItems.find(
      (elem: any) => elem.city.split(',')[0] == item
    );
    if (elem) {
      this.eventSelect(elem);
    }
  }

  ngOnInit(): void {
    if (this.activatedRoute.snapshot.params.company) {
      this.ws.newComplemt = this.activatedRoute.snapshot.params.company;
    }

    // excepcion para cikbus
    if (this.ws.newComplemt == 'buses-cikbus') {
      this.ws.newComplemt = 'cikbus';
    }
    // localStorage.removeItem('c171');
  }

  createPassager() {
    this.edit = false;
    this.viewPassenger = true;
  }

  editPassenger(item: any) {
    this.edit = true;
    this.element = item;
    this.viewPassenger = true;
  }

  selectPassenger(item: any) {
    this.eventEmit.emit(item);
  }

  async deleteTravelers(obj: any) {
    if (this.session.user && this.session.user.id && this.type === 2) {
      let eliminarRegistro: any;
      let seguroEliminar: any;
      let si: any;

      eliminarRegistro = await this.toolService.getTranslation(
        'menu.eliminarRegistro'
      );
      seguroEliminar = await this.toolService.getTranslation(
        'menu.seguroEliminar'
      );
      si = await this.toolService.getTranslation('menu.si');
      Swal.fire({
        title: eliminarRegistro,
        text: seguroEliminar,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#6732D4',
        confirmButtonText: si,
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.isConfirmed == true) {
          this.ws
            .selectType('travelers_delete', {
              passengerid: obj.id,
              accesstoken: this.session.getAccessToken() ?? null,
            })
            .then(
              (res) => {
                const data: PostDeleteTravelersAPI.ApiResponse = JSON.parse(
                  res as string
                );

                if (data.success) {
                  this.getTravelers();
                } else {
                  console.error('Error al eliminar el pasajero');
                }
              },
              (err) => {
                console.error('Error al eliminar el pasajero', err);
              }
            );
        }
      });
    }
  }

  onEmit(emit: any) {
    this.viewPassenger = false;
    this.edit = false;
    if (emit) {
      this.getTravelers();
    }
  }

  onClose(emit: any) {
    this.eventClose.emit(false);
  }

  initialize() {
    // es ida o regreso
    if (this.type === 0 || this.type === 1) {
      //! ESTO ESTA GENERANDO QUE DESAPAREZCAN LOS DESTINOS
      // let last: any = this.session.getLastWanted(this.ws.newComplemt);
      // if (last) {
      //   this.last = last.filter(item => { return item !== this.exclude });
      // }
      //TODO: REVISAR SU COMPORTAMIENTO
      // const debeActualizarListaCiudades = this.session.checkoutResetCities(this.ws.newComplemt);
      // if (debeActualizarListaCiudades) {
      //   this.getCities();
      // }
    }

    if (this.type === 2) {
      this.getTravelers();
    }
    //
    // if (this.type === 3) {
    //   this.items = this.session.listPassagers;
    // }
    //
    // if (this.type === 4 || this.type === 5 || this.type == 6) {
    //   this.items = this.navParams.get('items');
    //   this.allItems = this.navParams.get('items');
    // }
  }

  ngDoCheck() {
    if (this.doCheckRefresh) {
      this.doCheckRefresh = false;
      if (this.type == 0 || this.type == 1) {
        this.getCities();
      }
    }
  }

  ngAfterViewInit() {
    this.initialize();
    this.toolService.getComplement(this.activatedRoute).then(
      (response) => {
        this.ws.newComplemt = response;
      },
      (err) => {}
    );
  }

  getTravelers() {
    if (this.session.user && this.session.user.id) {
      this.ws
        .selectType('travelers_get', {
          accesstoken: this.session.getAccessToken(),
        })
        .then(
          (res) => {
            const data: GetTravelersAPI.ApiResponse = JSON.parse(res as string);
            if (data.success) {
              this.allItems = data.response.travelers;
              this.items = data.response.travelers;
            }
          },
          (err) => {
            console.error('Error al obtener los pasajeros', err);
          }
        );
    }
  }

  /**
   * Obtiene las Ciudades mas buscadas
   */
  getCities() {
    let cities = this.session.getCities(this.ws.newComplemt);
    const debeActualizarListaCiudades = this.session.checkoutResetCities(
      this.ws.newComplemt
    );

    if (cities && !debeActualizarListaCiudades) {
      this.allItems = cities.filter((item: any) => {
        if (item.city !== this.exclude) {
        }
        return item.city !== this.exclude;
      });

      //todo: revisar esta mal el filtro
      this.items = cities.filter((item: any) => {
        return item.city == !this.exclude;
      });

      // es destino
      // if (this.type == 1) {
      //   let lastCitySelected = this.session.getOriginSelected(this.ws.newComplemt);
      //   lastCitySelected = JSON.parse(lastCitySelected);

      //   if (lastCitySelected) {
      //     //todo: revisar el allitems
      //     let citiesReturn = this.loadCitiesPipe.transform(this.allItems, lastCitySelected.id);
      //     // let citiesReturn = lastCitySelected.destinos;
      //     this.items = citiesReturn ? citiesReturn: this.items;
      //     cities =  citiesReturn ? citiesReturn: cities;
      //   }
      // }

      // es origen
      if (this.type == 0) {
        this.items_sel = cities.sort((a, b) => {
          return b['searches_go'] - a['searches_go'];
        });
      }

      // es destino
      if (this.type == 1) {
        this.items_sel = cities.sort((a, b) => {
          return b['searches_to'] - a['searches_to'];
        });
      }
    } else {
      this.ws.selectType('cities', {}).then(
        (cities) => {
          let info: any;
          info = cities;
          this.items = JSON.parse(info);

          this.allItems = JSON.parse(info);
          if (this.type == 0) {
            this.items_sel = this.items.sort((a, b) => {
              return b['searches_go'] - a['searches_go'];
            });
          }
          if (this.type == 1) {
            this.items_sel = this.items.sort((a, b) => {
              return b['searches_to'] - a['searches_to'];
            });
          }

          if (this.items && this.items.length > 0) {
            this.session.deleteCitiesSaved(this.ws.newComplemt);
            this.session.loadCities(this.items, this.ws.newComplemt);
          }

          // this.session.loadCities(this.items, this.ws.newComplemt);
        },
        (err) => {
          console.error('Error al obtener las ciudades', err);
        }
      );
    }

    if (this.items_sel && this.last) {
      for (let i = 0; i < this.items_sel.length; i++) {
        for (let j = 0; j < this.last.length; j++) {
          if (this.items_sel[i].city.split(',')[0] == this.last[j]) {
            this.items_sel[i].marca = 0;
          }
        }
      }
    }
  }

  /**
   * Buscador de ciudades
   * @param ev
   * @returns
   */
  public getItems(ev: any) {
    if (this.allItems.length == 0) {
      this.initialize();
    }

    try {
      let val = ev.target;
      if (!val) {
        val = ev;
      } else {
        val = ev.target.value;
      }
      if (ev.length == 0) {
        this.items = this.allItems;
      }

      if (!ev || ev.length < 1) {
        this.muestra = false;
        this.search = false;
        return;
      }

      this.muestra = true;
      this.items = this.allItems;
      this.search = true;

      if (val) {
        if (this.type == 0 || this.type == 1 || this.type == 5) {
          // recontruye los items para guardar las ciudades de regreso
          // if (this.type == 1) {
          //   let lastCitySelected = this.session.getOriginSelected(this.ws.newComplemt);
          //   lastCitySelected = JSON.parse(lastCitySelected);

          //   if (lastCitySelected) {
          //     // let citiesReturn = this.loadCitiesReturn(this.items, lastCitySelected.id);
          //     let citiesReturn = this.loadCitiesPipe.transform(this.items, lastCitySelected.id);
          //     // let citiesReturn = lastCitySelected.destinos;
          //     this.items = citiesReturn ? citiesReturn: this.items;
          //   }
          // }

          this.items = this.items.filter((item: any) => {
            return item.city.toLowerCase().indexOf(val.toLowerCase()) > -1;
          });
        }
        if (this.type == 2) {
          this.items = this.items.filter((item: any) => {
            return (
              item.firstname.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
              item.lastname.toLowerCase().indexOf(val.toLowerCase()) > -1
            );
          });
        }
      }

      if (this.items.length == 0) {
        this.muestra = false;
      }

      if (this.type == 0 || this.type == 1 || this.type == 5) {
        const find = this.items.find((item: any) => {
          return item.city === this.select;
        });

        if (!find) {
          this.select = undefined;
        }
      }

      // if (ev && ev.length === 0) {
      // this.items = this.allItems;
      // }
    } catch (error) {}
  }
}
